import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TeamCard from '../../components/widgets/TeamCard';
import VerbHeading from '../../../shared/components/VerbHeading';
import WidgetCarousel from '../../components/widgets/WidgetCarousel';

const TeamsHomeRow = (props) => {
    const { onCardClick = () => { }, userTeams: userTeamsSorted = [] } = props;
    const loggedInUserId = useSelector(({ auth }) => auth?.loggedInUserId);
    const profiles = useSelector(({ profiles }) => profiles);
    const teams = useSelector(({ teams }) => teams?.byId);
    const activeUserTeams = [];
    const userTeams = userTeamsSorted.length ? userTeamsSorted : profiles?.byId[loggedInUserId]?.teams;

    (userTeams || []).forEach((team) => {
        if (teams && teams[team.teamId || team._id] && teams[team.teamId || team._id].isActive) {
            activeUserTeams.push({ ...teams[team.teamId || team._id], joinedDateTime: team.joinedDateTime });
        }
    })

    const teamCards = activeUserTeams.map((team, index) => (
        <div key={team._id}>
            <TeamCard
                team={team}
                index={index}
                onClick={() => {
                    onCardClick(team);
                }}
            />
        </div>
    ));

    if (teamCards.length) {
        return (
            <div className={'container home-row-wrapper teams-row'}>
                <div className={'heading-container'}>
                    <VerbHeading
                        className={'col-12 home-row-wrapper-heading'}
                        messageId={'TEAMS'}
                        hNumber={5}
                        defaultMessage={'Teams'}
                    />
                </div>
                <WidgetCarousel
                    className={'vertical-cards'}
                    displayItems={teamCards}
                    carouselSettings={'teamCards'}
                    cardOrientation={'vertical'}
                />
            </div>
        );
    }

    return null;
    
};

TeamsHomeRow.propTypes = {
    userTeams: PropTypes.array,
    onCardClick: PropTypes.func
};

export default TeamsHomeRow;
